module.exports = __webpack_public_path__ + "img/Warehouse01.3204dcb7.jpg";